import ipxRuntime_363tyKZHfgswhKhXN4Ei1zxZ7Q_45MJH58wto_gc0tSrM3M from '/var/www/html/node_modules/@nuxt/image/dist/runtime/providers/ipx'
import cloudflareRuntime_36fhrZFaCps5vrOO85lIzgr5ih3P3oP2z2Wq51zZ4kBtU from '/var/www/html/node_modules/@nuxt/image/dist/runtime/providers/cloudflare'

export const imageOptions = {
  screens: {"sm":640,"md":768,"lg":1024,"xl":1280,"2xl":1536,"2xs":320,"xs":480},
  presets: {},
  domains: [],
  alias: {},
  densities: [1,2],
  format: ["webp"],
  quality: 80,
  /** @type {"cloudflare"} */
  provider: "cloudflare",
  providers: {
      ['ipx']: { setup: ipxRuntime_363tyKZHfgswhKhXN4Ei1zxZ7Q_45MJH58wto_gc0tSrM3M, defaults: {"maxAge":2592000} },
  ['cloudflare']: { setup: cloudflareRuntime_36fhrZFaCps5vrOO85lIzgr5ih3P3oP2z2Wq51zZ4kBtU, defaults: {"baseURL":"https://cina-delicious-cakes.co.uk/","modifiers":{"format":"auto","quality":80,"onerror":"redirect"}} }
  }
}
